var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-entry-box" },
    [
      _c("title-block", { attrs: { title: _vm.title, classes: "is-3" } }),
      _c(
        "div",
        { staticClass: "box" },
        [
          !_vm.ready
            ? _c("SkeletonLoader", { attrs: { lines: _vm.lines } })
            : _vm._e(),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.ready
              ? _c(
                  "div",
                  { staticClass: "c-entry-box__content" },
                  [
                    _vm.contentType == "entry"
                      ? [
                          _vm.list && _vm.list.length
                            ? _c("EntryTable", {
                                attrs: { entries: _vm.entries }
                              })
                            : _vm._e()
                        ]
                      : [
                          _c("div", {
                            staticClass: "content",
                            domProps: { innerHTML: _vm._s(_vm.h(_vm.excerpt)) }
                          })
                        ]
                  ],
                  2
                )
              : _vm._e()
          ]),
          _c("div", { staticClass: "buttons is-centered" }, [
            _c(
              "a",
              { staticClass: "button is-primary", attrs: { href: _vm.href } },
              [_vm._m(0), _c("span", [_vm._v(_vm._s(_vm.title) + "一覧へ")])]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("i", { staticClass: "material-icons" }, [
        _vm._v("keyboard_arrow_right")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }